import Link from 'next/link'
import { useRouter } from 'next/router'
import * as React from 'react'

import { Icon } from '@wartek-id/icon'

import {
  Header as HeaderComposition,
  HeaderTitle,
  HeaderLeftAction,
  HeaderRightAction,
  BackgroundColor,
} from './HeaderComposition'

export interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string
  subtitle?: string
  backHref?: string
  hasBackButton?: boolean
  variant?: BackgroundColor
  replace?: boolean
  iconRightSrc?: string
  iconLeftSrc?: string
  onLeftActionClick?: (...args: any[]) => any
  onRightActionClick?: (...args: any[]) => any
  rightDropdownItemComponents?: React.ReactNode[]
  bordered?: boolean
}

export const Header = ({
  title,
  subtitle,
  backHref,
  hasBackButton = false,
  variant = 'default',
  replace = true,
  iconRightSrc,
  onLeftActionClick,
  onRightActionClick = () => {},
  bordered = true,
  ...props
}: HeaderProps) => {
  const router = useRouter()

  return (
    <HeaderComposition
      hasBorder={bordered}
      backgroundColor={variant}
      {...props}
    >
      {hasBackButton &&
        ((backHref && (
          <HeaderLeftAction>
            <Link href={backHref} replace={replace} legacyBehavior>
              <a href={backHref}>
                <Icon as="i">arrow_back</Icon>
              </a>
            </Link>
          </HeaderLeftAction>
        )) || (
          <HeaderLeftAction>
            <button
              onClick={() => {
                if (typeof onLeftActionClick === 'function') {
                  onLeftActionClick()
                } else {
                  router.back()
                }
              }}
            >
              <Icon as="i">arrow_back</Icon>
            </button>
          </HeaderLeftAction>
        ))}

      {title && (
        <HeaderTitle>
          <div className="flex flex-col items-center">
            <div className="text-base font-semibold">{title}</div>
            {subtitle && (
              <span className="text-sm text-type-basic-secondary">
                {subtitle}
              </span>
            )}
          </div>
        </HeaderTitle>
      )}

      {iconRightSrc && (
        <HeaderRightAction>
          <button onClick={onRightActionClick}>
            <Icon as="i">arrow_forward</Icon>
          </button>
        </HeaderRightAction>
      )}
    </HeaderComposition>
  )
}

export default Header
